module.exports = __webpack_public_path__ + "img/bdmail.a902b70d.png";